<template>
	<div class="base_box">

		<div class="base_form base_form_padding base_form_height">
			<div class="base_form_title">基本信息</div>
			<el-form class="mt20" ref="form" label-width="90px">
				<el-form-item label="商家编号">
					<el-input placeholder="请输入商家编号" size="small" v-model="post.code" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">设置公司编号，如SX00001</div>
				</el-form-item>
				<el-form-item label="商家名称">
					<el-input placeholder="请输入商家名称" size="small" v-model="post.name" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">设置供应商名称，如抢鲜颂数字</div>
				</el-form-item>
				<el-form-item label="商家分组" prop="selling_point">
					<el-select size="small" v-model="post.group_ids" multiple placeholder="请选择分组" style="width: 400px">
						<el-option v-for="item in selectData.type" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<div class="base_tips">选择供应商分组，方便统计供应商类型</div>
				</el-form-item>
				<el-form-item label="联系姓名" style="margin-bottom: 16px;">
					<el-input placeholder="请输入联系姓名" size="small" v-model="post.person_name" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">供应商联系人姓名</div>
				</el-form-item>
				<el-form-item label="联系电话" style="margin-bottom: 16px;">
					<el-input placeholder="请输入联系电话" size="small" v-model="post.mobile" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">供应商联系人电话</div>
				</el-form-item>
				<el-form-item label="联系邮箱" style="margin-bottom: 16px;">
					<el-input placeholder="请输入联系邮箱" size="small" v-model="post.email" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">供应商联系人邮箱</div>
				</el-form-item>
				<el-form-item label="联系座机" style="margin-bottom: 16px;">
					<el-input placeholder="请输入联系座机" size="small" v-model="post.fax" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">供应商联系人座机</div>
				</el-form-item>
			</el-form>
			<div class="base_form_title">经营信息</div>
			<el-form class="mt20" ref="form" label-width="90px">
				<el-form-item label="主营类目" prop="selling_point">
					<el-input placeholder="请输入主营类目" size="small" v-model="post.category" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">设置该供应商主营产品类目</div>
				</el-form-item>
				<el-form-item :hide-required-asterisk="true" label="品牌图像" >
				  <div class="goodsimage">
				    <div class="imgbox" @click="openimgplugin('log_id')">
				      <el-image v-if="post.log_id" :src="post.log_id_url" fit="cover"></el-image>
				      <i v-if="!post.log_id" class="el-icon-plus addicon"></i>
				      <div v-if="!post.log_id" class="text">添加图片</div>
				    </div>
				  </div>
				  <div class="base_tips">上传品牌图像，建议尺寸600*600，文件大小限制2M以内</div>
				</el-form-item>
				<el-form-item :hide-required-asterisk="true" label="营业执照" style="margin-bottom: 16px"
						prop="imagesIds">
						<div class="goodsimage">
							<draggable filter=".undraggable" style="
				  display: flex;
				  flex-wrap: wrap;
				  justify-content: flex-start;
				" v-model="post.business_images" :options="{ animation: 200 }">
								<div class="imgbox" v-for="(item, index) in post.business_images" :key="index">
									<el-image :src="item" fit="cover"></el-image>
									<i class="el-icon-error delicon" @click="delImagesId(index)"></i>
								</div>
								<div v-if="post.business_images.length < 10" class="imgbox undraggable" @click="
				    imgplugin.count = 11;
				    imgplugin.multiple = true;
				    openimgplugin('banner', 9);
				  ">
									<i class="el-icon-plus addicon"></i>
									<div class="text">添加图片</div>
								</div>
							</draggable>
							<div class="base_tips" style="width: 400px">文件大小限制2M以内</div>
						</div>
					</el-form-item>
				<el-form-item label="联系地址" prop="pay_type">
					<div class="mb10">
						<el-cascader size="small"  :options="options" placeholder="请选择省市区" style="width: 400px"
							v-model="addressCascader" @change="confirmAdrInfo"></el-cascader>
						<div class="base_tips">选择供应商所在的省市区</div>
					</div>
					<!-- <div class="mt10">
						<el-autocomplete size="small" class="inline-input" v-model="post.address" @input="iptAdr"
							:fetch-suggestions="querySearchFn" placeholder="请输入详细地址" @select="handleSelect"
							style="width: 400px">
							<template slot-scope="{ item }">
								<div class="name">{{ item.title }}</div>
								<div class="name" style="color: gray; font-size: 12px">
									{{ item.address }}
								</div>
							</template>
						</el-autocomplete>
					</div>
					<div class="base_tips">店铺经营地址（建议与营业执照一致）</div> -->
				</el-form-item>
				<!-- <el-form-item label="地图定位" prop="deduct_stock_type">
					<TencentMap ref="TencentMapRef" style="width: 400px" :center="{ lat: 31.2304, lng: 121.4737 }"
						@getQuerySearch="getQuerySearch" />
				</el-form-item> -->
				<el-form-item label="详细地址">
					<el-input placeholder="请输入详细地址" size="small" v-model="post.address" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">供应商详细通信地址</div>
				</el-form-item>
				<el-form-item label="备注信息">
					<el-input placeholder="请输入备注信息" size="small" v-model="post.remarks" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">备注供应商注意信息</div>
				</el-form-item>
			</el-form>
			<div class="base_form_title">账号信息</div>
			<el-form class="mt20" ref="form" label-width="90px">
				<el-form-item label="登录账号">
					<el-input placeholder="请输入登录账号" size="small" v-model="post.account" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">设置供应商登录账号，以11位数手机号</div>
				</el-form-item>
				<el-form-item  label="登录密码">
					<el-input placeholder="请输入登录密码" size="small" v-model="post.password" type="text" style="width: 400px;"></el-input>
					<div class="base_tips">设置供应商账号登录密码</div>
				</el-form-item>
				<!-- <el-form-item label="到期时间">
					<el-radio-group @input="radioChange" size="small" v-model="expire_time">
						<el-radio :label="1" style="margin-right: 12px">限制时间</el-radio>
						<el-radio :label="0">不限时间</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<el-form-item label="到期时间">
					<el-date-picker size="small" style="width: 400px;"
					      v-model="post.expire_time"
					      type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
					      placeholder="选择日期时间">
					    </el-date-picker>
					<div class="base_tips">设置供应商供货到期时间</div>	
				</el-form-item>
				<el-form-item label="账号状态">
					<el-radio-group size="small" v-model="post.status">
						<el-radio label="1" style="margin-right: 12px">启用</el-radio>
						<el-radio label="2">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</div>
		
		<div class="base_fixed_bottom">
			<el-button type="info" class="base_grey_but base_but_style base_return_but"  plain @click="toback">返回</el-button>
			<el-button type="primary" class="base_but_style base_save_but" @click="sendinfo">确定</el-button>
		</div>
		<xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple" :count="imgplugin.count" is_rest>
		</xsk-manage>
	</div>
</template>

<script>
	import {
		eltips
	} from "@/util/util.js";
	import TinymceEditor from "@/components/TinymceEditor/TinymceEditor";
	import draggable from 'vuedraggable';
	import TencentMap from "./components/TencentMap.vue";
	import baseModal from "@/components/common/baseModal.vue";
	export default {
		name: "basics",
		components: {
			draggable,TencentMap,baseModal,
			TinymceEditor
		},
		data() {
			return {
				addressCascader:[],
				detailsId:'',
				hideList:[],
				checkList:[],
				options: [],
				rich:{
					brand:false,
					hu:false
				},
				post:{
					id:'',
					account:'',
					password:'',
					status:'1',
					name:'',
					code:'',
					group_ids:[],
					person_name:'',
					mobile:'',
					address:'',
					email:'',
					fax:'',
					province:'',
					city:'',
					area:'',
					category:'',
					log_id:'',
					business_images:[],
					remarks:'',
					expire_time:''
				},
				imgplugin:{
					show:false,
					multiple:false,
					count:1,
					imgName:''
				},
				loading:false,
				querySearch:'',
				adrInfo:'',
				groupList:[],
				
				selectData:{
					type:[]
				}
			};
		},
		async created() {
			let _this = this
			await this.axios.get("/api/weishop/admin/region/tree").then((res) => {
				let data = this.getOptions(res.data);
				this.options = data || [];
			});
			let types = await _this.axios.get("/api/weishop/admin/plugin/erp/supplier/group/index",{
				params:{page:1,limit:1000}
			})
			_this.selectData.type = types.data.data
			if(this.$route.query.id){
				_this.detailsId = this.$route.query.id
				_this.axios
				  .get("/api/weishop/admin/plugin/erp/supplier/first/" + this.$route.query.id)
				  .then((res) => {
				    if (res.code == 200) {
						this.post.id = res.data.id
						this.post.account = res.data.account
						this.post.password = res.data.password
						if(res.data.pwd){
							this.post.password = res.data.pwd
						}
						if(res.data.group){
							this.post.group_ids = []
							res.data.group.map(redf=>{
								_this.post.group_ids.push(redf.id)
							})
						}
						this.post.status = res.data.status
						this.post.name = res.data.name
						this.post.code = res.data.code
						// this.post.group_ids = res.data.group_ids
						this.post.person_name = res.data.person_name
						this.post.mobile = res.data.mobile
						this.post.address = res.data.address
						this.post.email = res.data.email
						
						this.post.fax = res.data.fax
						this.post.province = res.data.province
						this.post.city = res.data.city
						this.post.area = res.data.area
						if(res.data.province){
							this.addressCascader = [res.data.province,res.data.city,res.data.area]
						}
						this.post.category = res.data.category
						this.post.log_id = res.data.log_id
						if(res.data.log_id){
							this.post.log_id_url = res.data.log.url
						}
						this.post.business_images = res.data.business_images
						this.post.remarks = res.data.remarks
						this.post.expire_time = res.data.expire_time
				    } else {
				      eltips(res.msg, "error");
				    }
				  });
			}
			
			  
			
		},
		methods: {
			radioChange(e){
				console.log("e",e)
				if(e=='1'){
					this.post.expire_time = ''
				}else{
					this.post.expire_time = '2099-12-31 23:59:59'
				}
			},
			getQuerySearch(data) {
				this.querySearch = data;
			},
			confirmAdrInfo(e) {
				console.log(e)
				this.addressCascader = e;
				this.post.province = e[0];
				this.post.city = e[1];
				this.post.area = e[2];
			},
			querySearchFn(queryString, cb) {
				// 调用 callback 返回建议列表的数据
				var restaurants = this.querySearch;
				cb(restaurants);
			},
			iptAdr(e) {
				this.$refs.TencentMapRef.geocodeAddress(e);
			},
			handleSelect(e) {
				this.post.cascader = this.findAreaIds(
					this.options,
					e.province,
					e.city,
					e.district
				);
				this.post.cascader = [e.province,e.city,e.district];
				this.post.province = e.province;
				this.post.city = e.city;
				this.post.area =e.district;
				this.adrInfo = e;
				this.post.address = e.address;
				this.post.lng = e.location.lng;
				this.post.lat = e.location.lat;
				this.$refs.TencentMapRef.addMarker({
					lat: this.post.lat,
					lng: this.post.lng,
				});
				this.$forceUpdate();
			},
			toback() {
				this.$router.go(-1);
			},
			getOptions(regions) {
				const {
					getOptions,
					getChildren
				} = this;
				const options = [];
				for (const index in regions) {
					const item = regions[index];
					const children = getChildren(item);
					const optionItem = {
						value: item.name,
						// value: item.id,
						// id: item.id,
						id: item.name,
						label: item.name,
						level: item.level,
						parent_id: item.pid,
					};
					if (children !== false) {
						optionItem.children = getOptions(children);
					}
					options.push(optionItem);
				}
				return options;
			},
			//删除轮播图
			delImagesId(index) {
				this.post.business_images.splice(index, 1);
			},
			sendinfo() {
				let _this = this
				let url = '/api/weishop/admin/plugin/erp/supplier/store'
				if(this.$route.query.id){
					url = url+'/'+this.$route.query.id
				}
				this.axios.post(url,_this.post).then((res) => {
					if(res.code == 200){
						eltips(res.msg, "success");
						_this.toback()
					}else{
						eltips(res.msg, "error");
					}
				})
			},
			//打开图片上传
			openimgplugin(e) {
				this.imgplugin.show = true
				this.imgplugin.imgName = e
			},
			//图片管理器回传
			imgpluginFun(e) {
				if (e.imgobjs.length == 0) {
					return
				}
				if (this.imgplugin.imgName == "log_id") {
					this.post[this.imgplugin.imgName] = e.imgobjs[0]['id']
					this.post[this.imgplugin.imgName+'_url'] = e.imgobjs[0]['url']
				} else {
					for (var i = 0; i < e.imgobjs.length; i++) {
						this.post.business_images.push(e.imgobjs[i]["url"]);
					}
				}
			},
			/**
			 * 在树形结构中查找省、市、区的 ID
			 * @param {Array} tree - 树形结构数据
			 * @param {String} provinceName - 省份名称
			 * @param {String} cityName - 城市名称
			 * @param {String} districtName - 区县名称
			 * @returns {Array} [provinceId, cityId, districtId]，未找到的层级返回 null
			 */
			findAreaIds(tree, provinceName, cityName, districtName) {
				const result = [];
			
				// 1. 查找省份
				const province = tree.find((node) => node.label === provinceName);
				if (!province) return [null, null, null];
				result.push(province.id);
			
				// 2. 查找城市
				if (province.children && cityName) {
					const city = province.children.find((node) => node.label === cityName);
					if (!city) return [province.id, null, null];
					result.push(city.id);
			
					// 3. 查找区县
					if (city.children && districtName) {
						const district = city.children.find(
							(node) => node.label === districtName
						);
						result.push(district ? district.id : null);
					}
				}
			
				return result;
			},
			// 获取子集地区
			getChildren(item) {
				if (item.city) {
					return item.city;
				}
				if (item.region) {
					return item.region;
				}
				return false;
			},

		},
	};
</script>


<style lang="less" scoped>
	::v-deep .el-tabs__item {
		height: 50px;
		line-height: 50px;
		font-size: 16px;
	}
	
	::v-deep .el-tabs__item.is-active {
		font-weight: 600;
	}
	
	::v-deep .tox-tinymce {
		border: 0;
		// background-color: #f8f8f8;
	}
	
	::v-deep .tox .tox-edit-area__iframe {
		// background-color: #f8f8f8;
	}
	
	::v-deep .tox .tox-toolbar,
	::v-deep .tox .tox-toolbar__overflow,
	::v-deep .tox .tox-toolbar__primary {
		// background-color: #f8f8f8;
		border: 0;
		background: #fff;
	}
	
	::v-deep .tox-toolbar__group {
		border: 0 !important;
	}
	
	::v-deep .tox-statusbar {
		display: none !important;
	}
	
	::v-deep .tox-statusbar__resize-handle {
		display: none !important;
	}
	
	::v-deep .tox .tox-statusbar {
		// background-color: #f8f8f8;
		border: 0;
	}
	
	::v-deep .el-tabs__item:hover {
		font-weight: 600;
	}
	
	::v-deep .el-tabs__nav-wrap::after {
		background-color: transparent !important;
	}
	
	::v-deep .el-checkbox__inner {
		// border-radius: 50% !important;
	}
	
	::v-deep .el-tabs__header {
		margin: 0 !important;
		display: block !important;
		justify-content: flex-start !important;
	}
	
	::v-deep .el-tabs__active-bar {
		height: 3px !important;
		border-radius: 4px !important;
	}
	
	::v-deep .el-table th {
		background-color: #f5f7fa;
	}
.goodsimage {
		.imgbox {
			border: 1px dashed #e9edef;
			// width: 170px;
			// height: 80px;
			width: 80px;
			height: 80px;
			margin-bottom: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			margin-right: 12px;
			position: relative;

			.img {
				width: 100%;
				height: 100%;
			}

			.addicon {
				font-size: 28px;
				color: #006aff;
			}

			.text {
				font-size: 12px;
				color: #b8b9bd;
				line-height: 16px;
			}

			.delicon {
				display: none;
				font-size: 20px;
				position: absolute;
				right: -8px;
				top: -8px;
			}

			&:hover {
				.delicon {
					display: block;
				}
			}
		}

		.imgbox2 {
			&:extend(.imgbox);
			width: 180px;
			height: 320px;
		}

		.advbox {
			width: 100px;
			height: 100px;
		}
	}
</style>